import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PodcastDetail } from '@src/components/sco/Education/PodcastDetail';
import { PodcastNumberRedirect } from '@src/components/sco/Education/PodcastNumberRedirect';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page() {
  const educationContext = useEducationContext();
  const routeParams = useParams();
  useUniversalEffect(() => {
    educationContext.setActiveSection('podcast.single');
  }, []);
  const slug = `${routeParams?.slug}`;
  console.log({
    slug
  });
  if (parseInt(slug) > 0) {
    return <PodcastNumberRedirect episodeNumber={slug} />;
  }
  return <PodcastDetail slug={`${routeParams.slug}`} />;
});